module.exports = __webpack_public_path__ + "static/media/prizm-golf-poster.4e23e453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-golf-poster.jpg
// module id = 3538
// module chunks = 0